import React from "react";
import { useNavigate } from "react-router-dom";
import strings from "../../../locales/ro.json";
import "./ContactingTab.css";

const s = strings.admin.contacting.list;

const groupColors = {
  Juniors: "#3B82F6",
  Seniors: "#8B5CF6",
  Freezed: "#94A3B8",
};

const groupLabels = {
  Juniors: s.juniors,
  Seniors: s.seniors,
};

const MemberStatusListItem = ({ user, variant, selectable, selected, onToggle }) => {
  const navigate = useNavigate();

  const handleNameClick = (e) => {
    e.stopPropagation();
    const uid = user.email?.split("@")[0];
    if (uid) navigate(`/profile/${uid}`);
  };

  return (
    <div
      className={`ct-member-item ${variant} ${selected ? "selected" : ""}`}
      onClick={selectable ? () => onToggle?.(user.id) : undefined}
      style={selectable ? { cursor: "pointer" } : undefined}
    >
      <div className="ct-member-main">
        {selectable && (
          <label className="ct-checkbox-wrapper" onClick={(e) => e.stopPropagation()}>
            <input
              type="checkbox"
              checked={selected}
              onChange={() => onToggle?.(user.id)}
            />
            <span className="ct-checkmark"></span>
          </label>
        )}
        <div className="ct-member-info">
          <span className="ct-member-name" onClick={handleNameClick}>
            {user.name}
          </span>
          <span
            className="ct-group-badge"
            style={{ backgroundColor: groupColors[user.groupName] || "#6B7280" }}
          >
            {groupLabels[user.groupName] || user.groupName}
          </span>
        </div>
      </div>
      <div className="ct-member-stats">
        <div className="ct-stat">
          <span className="ct-stat-value">{user.attendancePercentage}%</span>
          <span className="ct-stat-label">{s.attendanceLabel}</span>
        </div>
        <div className="ct-stat">
          <span className={`ct-stat-value ${variant}`}>
            {user.consecutiveAbsences === -1 ? "∞" : user.consecutiveAbsences}
          </span>
          <span className="ct-stat-label">{s.absencesLabel}</span>
        </div>
      </div>
    </div>
  );
};

const MemberStatusList = ({
  users = [],
  emptyMessage,
  variant = "danger",
  selectable = false,
  selectedIds = new Set(),
  onToggle,
}) => {
  if (users.length === 0) {
    return <p className="ct-empty">{emptyMessage}</p>;
  }

  return (
    <div className="ct-member-list">
      {users.map((user) => (
        <MemberStatusListItem
          key={user.id}
          user={user}
          variant={variant}
          selectable={selectable}
          selected={selectedIds.has(user.id)}
          onToggle={onToggle}
        />
      ))}
    </div>
  );
};

export default MemberStatusList;
